// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3VAXm","fileBtn":"File_fileBtn__2605b","closeBtn":"File_closeBtn__1T4IQ","fileSelected":"File_fileSelected__1hj9h","disabled":"File_disabled__1fDZs"};